module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/ripple/dist/mdc.ripple","commonjs2":"@material/ripple/dist/mdc.ripple","commonjs":"@material/ripple/dist/mdc.ripple","amd":"@material/ripple/dist/mdc.ripple","umd":"@material/ripple/dist/mdc.ripple"}
// module id = 15
// module chunks = 0